import { Injectable } from "@angular/core";
import { ErrorInterceptor } from "./ErrorInterceptor";
import { HttpClient } from "@angular/common/http";
import { CompanyFileDTO } from "../../../tsScripts/DTO/CompanyfileDTO";

declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class CompanyHttp {

    constructor(private http: HttpClient,
        private errorInterceptor: ErrorInterceptor) {

    }
    companyDetails(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company";
        let request = this.http.put(url, param);
        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyAgentList(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/agents";
        let request = this.http.put(url, param);
        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyProcessEdit(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyProcessCreate(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/create";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyProcessisActive(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/activate";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyAgentProfiles(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/profiles";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    listProfiles(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/rbac/profiles";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    listModelProfile(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/rbac/securitymodels";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    processAddProfile(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/profile/add";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    deleteProfiles(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/profile/delete";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    processEditProfile(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/profile/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    processCreateAgent(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/agent/create";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    processEditAgent(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/agent/edit";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    deleteAgents(param: any): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/agent/delete";
        let request = this.http.put(url, param);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    location(): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "biz/company/location";
        let request = this.http.put(url, null);

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    companyDelete(companyId: string) {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "support/company/delete";
        let request = this.http.put(url, { companyId: companyId });

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    fileEdit(files: CompanyFileDTO[]): Promise<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "company/file/edit";
        let request = this.http.put(url, { files: files });

        return new Promise((resolve, reject) => {
            request.subscribe((response: any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
}

